import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["heading", "isComplete", "isSelected", "subheading", "url"];
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { safeSmoothScrollTo } from '../../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'expanded-track-navigator-top-level';
const ExpandedTrackNavigatorTopLevel = _ref => {
  let {
      heading,
      isComplete,
      isSelected,
      subheading,
      url
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = useLocation();
  const classModifier = isSelected ? 'selected' : 'unselected';
  return /*#__PURE__*/_jsx("div", Object.assign({
    className: classNames(BASE_CLASS_NAME, `${BASE_CLASS_NAME}--${classModifier}`, isComplete && `${BASE_CLASS_NAME}--with-icon`)
  }, rest, {
    children: /*#__PURE__*/_jsxs(UIRouterLink, {
      "aria-selected": isSelected,
      className: `${BASE_CLASS_NAME}__link`,
      onClick: () => {
        safeSmoothScrollTo(window, 0, 0);
      },
      to: Object.assign({}, location, {
        pathname: url
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx("div", {
        className: `${BASE_CLASS_NAME}__heading`,
        children: heading
      }), /*#__PURE__*/_jsx("div", {
        className: `${BASE_CLASS_NAME}__subheading`,
        children: subheading
      }), isComplete && /*#__PURE__*/_jsx(UIIcon, {
        className: `${BASE_CLASS_NAME}__complete-icon`,
        "data-test-id": "complete-icon",
        name: "success",
        size: "xs"
      })]
    })
  }));
};
export default ExpandedTrackNavigatorTopLevel;